import { Stack } from "@mui/material";
import Introduction from "./IntroductionSection/Introduction";
const IndustriesComponent = ({data, index }) => {
  return (
    <Stack>
      <Stack sx={{ height: "auto", display: "flex", flexDirection: "column" }}>
        <Stack sx={{ height: "76vh" }}>
          {" "}
          <Stack sx={{ height: "100%", width: "100%" }}>
            <Introduction data={data} index={index}/>
          </Stack>
        </Stack>{" "}
      </Stack>
    </Stack>
  );
};

export default IndustriesComponent;
